var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onCloseOption,
          expression: "onCloseOption",
        },
      ],
      staticClass: "select-options",
      class: { isOpenControlMenu: _vm.isOpenControlMenu },
      style: { ..._vm.position },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return (() => {}).apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "select-header" }, [_vm._v(_vm._s(_vm.title))]),
      _vm.type === "radio"
        ? _c(
            "div",
            { staticClass: "select-body" },
            _vm._l(_vm.list, function (item) {
              return _c("div", { key: item.value }, [
                _c(
                  "label",
                  {
                    staticClass: "select-item",
                    on: { click: _vm.onChangedOption },
                  },
                  [
                    _c("input", {
                      attrs: { type: "radio", name: `grm-select-${_vm.name}` },
                      domProps: {
                        checked: _vm.value == item.value,
                        value: item.value,
                      },
                    }),
                    _c("div", [
                      _c("div", [_vm._v(_vm._s(item.name))]),
                      item.message
                        ? _c("div", { staticClass: "item-message" }, [
                            _vm._v(_vm._s(item.message)),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.type === "checkbox"
        ? _c(
            "div",
            { staticClass: "select-body" },
            _vm._l(_vm.list, function (item, idx) {
              return _c("div", { key: item.value || idx }, [
                _c(
                  "label",
                  {
                    staticClass: "select-item",
                    on: { click: _vm.onChangedOption },
                  },
                  [
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        name: `grm-select-${_vm.name}`,
                      },
                      domProps: { checked: _vm.checkboxValue[idx], value: idx },
                    }),
                    _c("div", [
                      _c("div", [_vm._v(_vm._s(item.name))]),
                      item.message
                        ? _c("div", { staticClass: "item-message" }, [
                            _vm._v(_vm._s(item.message)),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._t("default"),
      _c("div", { staticClass: "select-footer" }, [
        _c(
          "button",
          {
            staticClass: "select-footer-button select-cancel",
            on: { click: _vm.onCloseOption },
          },
          [_vm._v(_vm._s(_vm.button[0] || _vm.$t("common.cancel")))]
        ),
        _c(
          "button",
          {
            staticClass: "select-footer-button select-save",
            on: { click: _vm.onNextAct },
          },
          [_vm._v(_vm._s(_vm.button[1] || _vm.$t("common.confirm")))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }